import React, { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { navLinks, profile } from "../data/mock";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-[#F8F5EE]/95 backdrop-blur border-b border-[#0B1E3F]/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto container-px flex items-center justify-between h-20">
        <a href="#top" className="flex items-center gap-3 group">
          <img
            src="/images/dr-hardik-mark.png"
            alt="Dr. Hardik Barot"
            className="h-10 lg:h-11 w-auto object-contain"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="nav-underline text-[13px] tracking-[0.15em] uppercase text-[#0B1E3F]/80 hover:text-[#0B1E3F]"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a href={`tel:${profile.contact.phone.replace(/\s/g, "")}`} className="btn-ghost text-sm">
            <Phone size={14} />
            Book a Consult
          </a>
        </div>

        <button
          aria-label="Open menu"
          onClick={() => setOpen(!open)}
          className="lg:hidden p-2 text-[#0B1E3F]"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-500 ${
          open ? "max-h-[420px] border-b border-[#0B1E3F]/10 bg-[#F8F5EE]" : "max-h-0"
        }`}
      >
        <div className="max-w-7xl mx-auto container-px py-6 flex flex-col gap-4">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-sm tracking-[0.15em] uppercase text-[#0B1E3F]/80"
            >
              {l.label}
            </a>
          ))}
          <a href={`tel:${profile.contact.phone.replace(/\s/g, "")}`} className="btn-primary text-sm w-fit">
            <Phone size={14} /> Book a Consult
          </a>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
